import { hasHelpDeskAccess } from 'conversations-thread-data/auth/public/selectors';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
export const withHelpdeskAccess = Component => {
  const ComponentWithCurrentTicketId = props => {
    const userHasHelpdeskAccess = useSelector(hasHelpDeskAccess);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      userHasHelpdeskAccess: userHasHelpdeskAccess
    }));
  };
  ComponentWithCurrentTicketId.displayName = `withHelpdeskAccess(${Component.displayName})`;
  return ComponentWithCurrentTicketId;
};